import { render, staticRenderFns } from "./p-producer.vue?vue&type=template&id=7947813a&scoped=true&"
import script from "./p-producer.vue?vue&type=script&lang=js&"
export * from "./p-producer.vue?vue&type=script&lang=js&"
import style0 from "./p-producer.vue?vue&type=style&index=0&id=7947813a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7947813a",
  null
  
)

export default component.exports